export class ResponseItemModel {

  // SP Response
  engLeftSideDocId: number;
  engTeamClientDocId: number;
  extension: string;
  extensionPath: string;
  fileName: string;
  filePath: string;
  // we need to make sure that in case of any error in SP, we will not attempt to copy the file in S3
  isFileExistInTheLeft = true;
  fileHashId: string;
  originalFileName: string;
  s3Directory: string;
  vStep: number;
  mssdkfileid:string;
  
  // Workflow Handling in UI
  status: number;
  resultCode: string; // This can be success, error, warning
  message: string;
}
